import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import ActionResult from 'visuris/Data/DTOs/ActionResult';
import BerthReservation from 'visuris/Data/Entities/BerthReservation';
import BerthReservationShip from 'visuris/Data/Entities/BerthReservationShip';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import * as facilityhelp from 'visuris/Helpers/FacilityHelper';

export default class BerthReservationRepository extends BaseRepository<BerthReservation> {

    // See constructor
    private GETBERTHRESERVATIONS = "";
    private GETBERTHRESERVATION = "";
    private GETBERTHRESERVATIONWITHUSERDATA = "";
    private GETBERTHRESERVATIONSFORUSER = "";
    private GETBERTHRESERVATIONSFORTERMINALOWNER = "";
    private GETSCHEDULEDBERTHRESERVATIONSFORISRS = "";
    private GETBERTHRESERVATIONSFORISRS = "";
    private ISBERTHRESERVABLEBYUSER = "";
    private SAVEBERTHRESERVATION = "";
    private APPROVEBERTHRESERVATION = "";
    private DENYBERTHRESERVATION = "";
    private SAVESHIPARRIVALATBERTHRESERVATION = "";
    private FINISHBERTHRESERVATION = "";
    private CANACTIVATERESERVATIONS = "";
    private ISBERTHMYBERTH = "";
    private CANMANAGERESERVATIONS = "";
    private ISACTIVEBERTH = "";
    private CANMAKERESERVATION = "";
    private CANMAKERESERVATIONTHIRDPARTY = "";

    constructor() {
        super();
        this.GETBERTHRESERVATIONS = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservations");
        this.GETBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservation?reservationID=");
        this.GETBERTHRESERVATIONWITHUSERDATA = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservationwithuserdata?reservationID=");
        this.GETBERTHRESERVATIONSFORUSER = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservationsforuser?userID=");
        this.GETBERTHRESERVATIONSFORTERMINALOWNER = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservationsforterminalowner?userID=");
        this.GETSCHEDULEDBERTHRESERVATIONSFORISRS = app.formatLocationUrl("~/visuris/api/berthreservations/getscheduledberthreservationsforisrs?isrs=");
        this.GETBERTHRESERVATIONSFORISRS = app.formatLocationUrl("~/visuris/api/berthreservations/getberthreservationsforisrs?isrs=");
        this.ISBERTHRESERVABLEBYUSER = app.formatLocationUrl("~/visuris/api/berthreservations/isberthreservablebyuser?isrs=");
        this.SAVEBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/saveberthreservation");
        this.APPROVEBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/approveberthreservation");
        this.DENYBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/denyberthreservation");
        this.SAVESHIPARRIVALATBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/saveshiparrivalatberthreservation");
        this.FINISHBERTHRESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/finishberthreservation");
        this.CANACTIVATERESERVATIONS = app.formatLocationUrl("~/visuris/api/berthreservations/CanActivateReservations?isrs=");
        this.CANMANAGERESERVATIONS = app.formatLocationUrl("~/visuris/api/berthreservations/CanManageReservations?isrs=");
        this.ISBERTHMYBERTH = app.formatLocationUrl("~/visuris/api/berthreservations/IsBerthMyBerth?isrs=");
        this.ISACTIVEBERTH = app.formatLocationUrl("~/visuris/api/berthreservations/IsActiveBerth?isrs=");
        this.CANMAKERESERVATION = app.formatLocationUrl("~/visuris/api/berthreservations/CanMakeReservation");
        this.CANMAKERESERVATIONTHIRDPARTY = app.formatLocationUrl("~/visuris/api/berthreservations/CanMakeReservationThirdParty");
    }

    public list(): Promise<BerthReservation[]> {
        return new Promise<BerthReservation[]>((resolve, reject) => {
            var $get = $.get(this.GETBERTHRESERVATIONS);
            $get.then((data) => {
                var reservations: BerthReservation[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    reservations.push(BerthReservationRepository.fromDTO(item));
                }
                resolve(reservations);
            }, () => {
                reject();
            });
        });
    }


    public canActivateBerthreservations(isrs:string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.CANACTIVATERESERVATIONS +isrs);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public canManageBerthreservations(isrs:string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.CANMANAGERESERVATIONS + isrs);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }


    public canMakeReservation(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.CANMAKERESERVATION);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }
    public canMakeReservationThirdParty(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.CANMAKERESERVATIONTHIRDPARTY);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public isActiveBerth(isrs: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.ISACTIVEBERTH + isrs);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public isBerthMyBerth(isrs: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.ISBERTHMYBERTH + isrs);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }


    public get(id: string): Promise<BerthReservation> {
        return new Promise<BerthReservation>((resolve, reject) => {
            var $get = $.get(this.GETBERTHRESERVATION + id);
            $get.then((data) => {
                resolve(BerthReservationRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }
    public getWithUserData(id: string): Promise<BerthReservation> {
        return new Promise<BerthReservation>((resolve, reject) => {
            var $get = $.get(this.GETBERTHRESERVATIONWITHUSERDATA + id);
            $get.then((data) => {
                resolve(BerthReservationRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public getBerthReservationsForUser(userID: string): Promise<BerthReservation[]> {
        return new Promise<BerthReservation[]>((resolve, reject) => {
            var $get = $.get(this.GETBERTHRESERVATIONSFORUSER + userID);
            $get.then((data) => {
                var reservations: BerthReservation[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    reservations.push(BerthReservationRepository.fromDTO(item));
                }
                resolve(reservations);
            }, () => {
                reject();
            });
        });
    }

    public getBerthReservationsForTerminalOwner(userID: string): Promise<BerthReservation[]> {
        return new Promise<BerthReservation[]>((resolve, reject) => {
            var $get = $.get(this.GETBERTHRESERVATIONSFORTERMINALOWNER + userID);
            $get.then((data) => {
                var reservations: BerthReservation[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    reservations.push(BerthReservationRepository.fromDTO(item));
                }
                resolve(reservations);
            }, () => {
                reject();
            });
        });
    }

    public getScheduledBerthReservationsForISRS(isrs: string, fromDate?: Date, toDate?: Date): Promise<BerthReservation[]> {
        return new Promise<BerthReservation[]>((resolve, reject) => {
            var url = this.GETSCHEDULEDBERTHRESERVATIONSFORISRS + isrs;
            if (fromDate != null) {
                url += '&fromDate=' + fromDate.toISOString();
            }
            if (toDate != null) {
                url += '&toDate=' + toDate.toISOString();
            }
            var $get = $.get(url);
            $get.then((data) => {
                var berthReservations: BerthReservation[] = [];
                for (let i = 0; i < data.length; i++) {
                    berthReservations.push(BerthReservationRepository.fromDTO(data[i]));
                }
                resolve(berthReservations);
            }, () => {
                reject();
            });
        });
    }

    public getBerthReservationsForISRS(isrs: string, fromDate?: Date, toDate?: Date): Promise<BerthReservation[]> {
        return new Promise<BerthReservation[]>((resolve, reject) => {
            var url = this.GETBERTHRESERVATIONSFORISRS + isrs;
            if (fromDate != null) {
                url += '&fromDate=' + fromDate.toISOString();
            }
            if (toDate != null) {
                url += '&toDate=' + toDate.toISOString();
            }
            var $get = $.get(url);
            $get.then((data) => {
                var berthReservations: BerthReservation[] = [];
                for (let i = 0; i < data.length; i++) {
                    berthReservations.push(BerthReservationRepository.fromDTO(data[i]));
                }
                resolve(berthReservations);
            }, () => {
                reject();
            });
        });
    }

    public isBerthReservableByUser(isrs: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $get = $.get(this.ISBERTHRESERVABLEBYUSER + isrs);
            $get.then((result) => {
                resolve(<boolean>result);
            }, () => {
                reject();
            });
        });
    }

    public saveBerthReservation(reservation: BerthReservation): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.SAVEBERTHRESERVATION, data: JSON.stringify(reservation), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public approveBerthReservation(reservation: BerthReservation): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.APPROVEBERTHRESERVATION, data: JSON.stringify(reservation), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public denyBerthReservation(reservation: BerthReservation): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.DENYBERTHRESERVATION, data: JSON.stringify(reservation), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public saveShipArrivalAtBerthReservation(reservation: BerthReservation): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.SAVESHIPARRIVALATBERTHRESERVATION, data: JSON.stringify(reservation), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public finishBerthReservation(reservation: BerthReservation): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.FINISHBERTHRESERVATION, data: JSON.stringify(reservation), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public static fromDTO(item: any): BerthReservation {
        var reservation = new BerthReservation();
        reservation.id = item.id;
        reservation.reservationFromTS = new Date(item.reservationFromTS);
        reservation.reservationToTS = new Date(item.reservationToTS);
        reservation.reservationStatus = item.reservationStatus;
        reservation.reservationStatusReason = item.reservationStatusReason;
        reservation.reservationName = item.reservationName;
        reservation.reservationType = item.reservationType;
        reservation.isrs = item.isrs;
        reservation.reservationStartPos = item.reservationStartPos;
        reservation.reservationEndPos = item.reservationEndPos;
        reservation.remark = item.remark;
        reservation.ata = new Date(item.ata);
        reservation.atd = new Date(item.atd);
        reservation.awfUserId = item.awfUserId;
        reservation.requiredMaterial = item.requiredMaterial;
        reservation.applicantPhoneNumber = item.applicantPhoneNumber;
        reservation.applicantFaxNumber = item.applicantFaxNumber;
        reservation.applicantEmail = item.applicantEmail;
        reservation.applicantName = item.applicantName;
        reservation.licenseHolderName = item.licenseHolderName;
        reservation.licenseNumber = item.licenseNumber;
        reservation.requiredSurface = item.requiredSurface;
        reservation.scheduleChangeReason = item.scheduleChangeReason;
        reservation.berthName = item.berthName;
        reservation.userFirstName = item.userFirstName;
        reservation.userLastName = item.userLastName;
        reservation.berthReservationShips = [];
        if (item.berthReservationShips != null) {
            for (let i = 0; i < item.berthReservationShips.length; i++) {
                reservation.berthReservationShips.push(BerthReservationRepository.toBerthReservationShip(item.berthReservationShips[i]));
            }
        }
        reservation.reservationStatusMessage = item.reservationStatusMessage;
        reservation.reservationTypeMessage = item.reservationTypeMessage;
        return reservation;
    }

    public static toBerthReservationShip(item: any): BerthReservationShip {
        var ship = new BerthReservationShip();
        ship.id = item.id;
        ship.berthReservationID = item.berthReservationID;
        ship.matchID = item.matchID;
        ship.vesselName = item.vesselName;
        ship.vesselMMSI = item.vesselMMSI;
        ship.vesselENI = item.vesselENI;
        ship.vesselIMO = item.vesselIMO;
        ship.requiredLength = item.requiredLength;
        ship.requiredWidth = item.requiredWidth;
        ship.tonnage = item.tonnage;
        ship.cones = item.cones;
        ship.adnCargo = item.adnCargo;
        ship.hsCargo = item.hsCargo;
        ship.remark = item.remark;
        ship.adnCargoMessage = item.adnCargoMessage;
        ship.hsCargoMessage = item.hsCargoMessage;
        return ship;
    }
}

